<template>
    <div>
        <component :is="currentComponent" @goToComponent="handleComponentChange" :money="componentParams.money">
        </component>
    </div>
</template>
<script>
import PurchasesList from './Purchases/PurchasesList.vue'
import PurchasesDetail from './Purchases/PurchasesDetail.vue'

export default {
    name: 'MyPurchases',
    components: {
        PurchasesList,
        PurchasesDetail,
    },
    data() {
        return {
            currentComponent: 'PurchasesList',
            componentParams: {
                
            }
        }
    },
    mounted() {
        // 支持从外部（如结算单）带采购单 aid 直接进入采购详情
        const purchaseId = this.$route.query.purchaseId;
        if (purchaseId) {
            this.componentParams = { purchaseId };
            this.currentComponent = 'PurchasesDetail';
        } else {
            this.currentComponent = 'PurchasesList';
        }
    },
    methods: {
        // 处理组件切换
        handleComponentChange(componentName, params) {
            if (params) {
                this.componentParams = { ...this.componentParams, ...params };
            }
            this.currentComponent = componentName;
        }
    }
}
</script>
<style scoped>
/* 可以根据需要添加样式 */
</style>